import { render, staticRenderFns } from "./public-holiday-form.vue?vue&type=template&id=bccc4a50&scoped=true"
import script from "./public-holiday-form.vue?vue&type=script&lang=js"
export * from "./public-holiday-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccc4a50",
  null
  
)

export default component.exports